export const DISPONIBILE = 1
export const OCCUPATA = 2
export const DISABILITATA = 3
export const RISERVATA = 4
export const CHECKIN = 5